import React, { useState, useEffect, useContext } from 'react';
import ENVIRONMENT from '../../../../environments';
import * as Constants from "../../CustomerComponents/Constants";
import { Tooltip, Row, Card, Col, Checkbox, Button } from 'antd';
import { CloseOutlined, LoadingOutlined, InfoCircleOutlined, FlagOutlined, ArrowRightOutlined, DeleteOutlined } from '@ant-design/icons';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import CollaborateQACanvas from './CollaborateQACanvas';
import CollaborateCanvasToolbar from './CollaborateCanvasToolbar';
import * as Styles from "../../../../Styles";
import ImageMagnify from '../ImageMagnify/ImageMagnify';
import Annotation from '../CollaborateTool/Annotation';
import ZoomImage from '../ProductComponents/imageZoomable';
import * as Utilities from '../../Utilities';
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
const progress_bar = Styles.progress_bar;

const CUSTOMER_USERNAME = localStorage.getItem('username');
const COMPANY_ID = localStorage.getItem("company_id");
const SHARED_ENTITIES = localStorage.getItem("shared_entities");
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;

const ImageListType = (props) => {
    const { productQAImages, collaborateMode, setTourStep, tourStep,
        selectedProductImage, setViewType, openDeleteModal } = useContext(CollaborateQAContext);

    return (productQAImages && productQAImages.filter(image => image.main_type == props.type).length > 0 ?
        <>
            <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
                <div className='manrope f-14 black-26'>{props.name}</div>
                {props.tooltipInfo && 
                    <Tooltip placement='bottom' title={<span className="manrope f-12 white">{props.tooltipInfo}</span>}>
                        <InfoCircleOutlined style={{color: "#276DD7", marginLeft: '8px'}}/>
                    </Tooltip>
                }
            </div>
            <Button className='nav-btns black-grey qa-settings f-14' onClick={() => {setViewType('comparison_view')}}>
                Create your own&nbsp;<ArrowRightOutlined/>
            </Button>
            {productQAImages.filter(image => image.main_type == props.type).map((image, index) => (
                <Card id={image.id}
                    data_tut={`${index == 0 ? `reactour__tourStep1`: ``}`}
                    className={`product-qa-img-grid-card display-flex ${selectedProductImage == image.url ? `selected` : ``}`}
                    key={index} onClick={() => { props.selectImage(image.url, props.type ) }}>
                    <img className='product-img-grid-img' src={image.low_url} />
                    {image.annotation_count > 0 ?
                        <Tooltip title={<span className='manrope f-12 white'>This image has {image.annotation_count} annotation(s).</span>}>
                            <div className='annotation-circle justify-in-center'>
                            </div>
                        </Tooltip> : ''}
                    
                    <Tooltip title={<span className='manrope f-14 white'>Delete this image</span>}>
                            <DeleteOutlined className='del-btn-bg manrope f-12 white' onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(image);
                            }} />
                    </Tooltip>
                </Card>
            ))}
        </> : "")
}

const ImageListTypePreviews = (props) => {
    const { productQAImages, collaborateMode, selectedProductImage } = useContext(CollaborateQAContext);

    return (productQAImages && productQAImages.filter(image => image.main_type == props.type).length > 0 ?
        <>
            <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
                <div className='manrope f-14 black-26'>{props.name}</div>
                {props.tooltipInfo && 
                    <Tooltip placement='bottom' title={<span className="manrope f-12 white">{props.tooltipInfo}</span>}>
                        <InfoCircleOutlined style={{color: "#276DD7", marginLeft: '8px'}}/>
                    </Tooltip>
                }
            </div>
            {productQAImages.filter(image => image.main_type == props.type).map((image, index) => (
                <Card id={image.id}
                    className={`product-img-grid-card qa-preview display-flex ${selectedProductImage == image.url ? `selected` : ``}`}
                    key={index} onClick={() => { props.selectImage(image.url, props.type) }}>
                    <img className='product-img-grid-img' src={image.low_url} />
                    {collaborateMode && image.annotation_count > 0 ?
                        <Tooltip title={<span className='manrope f-12 white'>This image has {image.annotation_count} annotation(s).</span>}>
                            <div className='annotation-circle justify-in-center'>
                            </div>
                        </Tooltip> : ''}
                </Card>
            ))}
        </> : "")
}


const ProductCollaborateQAContainer = () => {
    const { canvas_editor, productQAImages, selectedProductImage, refImagePhotoList, setRefImagePhotoList, setErrorMessage,
        setSelectedProductImage, canvasJson, setCanvasJson, productAssetData, getAnnotations, toggleAnnotateDisplay,
        collaborateMode, repopulateSavedProgress, canvasLoader, imageUploadLoader, setDataAutoSaved, setCanvasLoader,
        initialLoader, projectID, openDeleteModal, dontShowAgain, changeTourVisibility, tourStep, 
        selectedImageType, setSelectedImageType, getProductQAImagery, setInitialLoader,
        setSelectComparisonImageModal, access_level, closeCommentHistoryDrawer, setAnnotationDisplayToggle,
        selectedCollaborationID, setSelectedCollaborationID, setInitialJSON, hideProductBanner, setHideProductBanner,
        autoSaveLoader, autoSaveData, displayLoader, setDisplayLoader, repopulated, save_loader, closeTour1, setTourStep,
    annotateLoader, refreshLoader, productData } = useContext(CollaborateQAContext);

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const disableBody = target => disableBodyScroll(target);
    const enableBody = target => enableBodyScroll(target);

    const selectImage = (url, type) => {
        console.log("Selecting image.. ");
        let current_canvas_data = canvas_editor.convertToJSON();
        const dict = { ...canvasJson };
        let new_image_id = getQAID(url); // new image
        let old_image_id = getQAID(selectedProductImage); // previously selected image
        if (new_image_id != selectedCollaborationID) { // do all of this if the same image is not selected
            dict[old_image_id] = current_canvas_data;
            setCanvasJson(dict);
            setInitialJSON(current_canvas_data);

            // setDataAutoSaved(false); // so we know its not autosaved here
            if (autoSaveLoader || displayLoader || save_loader || annotateLoader || refreshLoader || canvasLoader) {

            } else {
                if (collaborateMode) {
                    autoSaveData();
                }
            }
            
            setSelectedImageType(type)
            setDisplayLoader(true); // loader before image is loaded
            setCanvasLoader(true); // loader to before canvas is repopulated
            setSelectedProductImage(url); // setting new image url
            display_loader_and_set_image(url); // set image loader to false here after image has loaded
            toggleAnnotateDisplay("none"); // comments box should close on new image
            closeCommentHistoryDrawer(); // comment drawer (list) should close on new image
            setSelectedCollaborationID(new_image_id);
            setAnnotationDisplayToggle(true);
            getAnnotations(new_image_id);
            repopulateSavedProgress(new_image_id, url);
        }

    }

    const display_loader_and_set_image = (image_src) => {
        image_src = image_src.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(productAssetData['platform']))
        const img = new Image();
        img.onload = function () {
            setDisplayLoader(false);
            setSelectedProductImage(image_src);
            forceUpdate();
        }
        img.src = image_src;
    }

    const getQAID = (url) => {
        let ids = productQAImages.filter(item => item.url == url);
        if (ids.length > 0) {
            return ids[0].id;
        }
    }

    const setCookie = (cname, cvalue, exdays) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    const hideBanner = () => {
        setHideProductBanner(true);
        setCookie("hide-banner-product-qa", true, 365);
    }


    return (<Row className='product-qa-img-tool-container'>
        <Col md={6} lg={6} xl={4} className={` ${initialLoader || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}>
            {imageUploadLoader && <LoadingOutlined className='manrope f-32 justify-in-center' />}
            <div className={`display-flex j-s a-s wrap sa-s gg-16 custom-scroll product-grid-list ${(["co-owner", "owner"].includes(access_level) || (projectID && access_level == "edit")) ? `qa` : `qa-editor`} w-100`}>
                <div className='manrope f-16 black-26 w-100'>Your Images</div>
                <ImageListTypePreviews
                    collaborateMode={collaborateMode}
                    productQAImages={productQAImages}
                    type={"low_res_preview"}
                    name={"Previews"}
                    selectImage={selectImage}
                    selectedProductImage={selectedProductImage}
                    tooltipInfo={"Previews are rendered images of the 3D model at a lower resolution."}
                />
                <ImageListType
                    openDeleteModal={openDeleteModal}
                    collaborateMode={collaborateMode}
                    productQAImages={productQAImages}
                    type={"comb_image"}
                    name={"Comparisons"}
                    selectImage={selectImage}
                    selectedProductImage={selectedProductImage}
                    tooltipInfo={"Comparisons show a preview of the 3D model on the left and the reference image on the right."}
                />
            </div>
        </Col>

        <Col md={18} lg={18} xl={20} className='w-100'>
            {hideProductBanner == false  &&
                <div style={{position: 'absolute', zIndex: '2', width: '99.6%', marginLeft: '5px'}}>
                    <div className={`product-banner  ${initialLoader || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}>
                        <div className='manrope f-12 black-33 justify-space-between lh-14'>
                            <div>
                                <FlagOutlined style={{color: '#AD6800', fontSize: '15px'}}/>
                                <span style={{color: '#AD6800', marginLeft: '8px'}}>New here? Review your model by adding feedback using the toolbar below and inviting others to collaborate. </span>
                            </div>
                            <CloseOutlined style={{color: '#AD6800'}} onClick={hideBanner} />
                        </div>
                    </div>
                </div>
                }
            <CollaborateQACanvas />

            {collaborateMode ? <CollaborateCanvasToolbar /> : ''}
            {collaborateMode ? <Annotation context_for={"collaborate_qa"} /> : ''}
            {
                selectedImageType == 'comb_image' ?
                <div className={`${initialLoader  || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}> 
                    <div className={`manrope f-14 black product-comparison-img-tag left ${hideProductBanner ? '' : 'banner-top'}`}>Preview</div>
                    <div className={`manrope f-14 black product-comparison-img-tag right ${hideProductBanner ? '' : 'banner-top'}`}>Reference Image</div>
                </div> : 
                selectedImageType == 'low_res_preview' ? 
                    <div className={`manrope f-14 black product-comparison-img-tag left ${hideProductBanner ? '' : 'banner-top'} ${initialLoader  || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}>Preview</div> :
                    <div className={`manrope f-14 black product-comparison-img-tag right ${hideProductBanner ? '' : 'banner-top'} ${initialLoader  || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``}`}>Reference Image</div>
            }
            {collaborateMode ? "" : <ZoomImage
                className="product-qa-image-zoom"
                image={selectedProductImage} />}
            {displayLoader || (canvasLoader && collaborateMode) ? <LoadingOutlined className='image-loader-qa' /> : ""}

            <Tour
                steps={[
                    {
                        selector: `[data_tut="reactour__tourStep1"]`,
                        content: () => (
                            <div>
                                <p className='manrope f-14 lh-22 w-500 black-085 mb-16'>
                                    Comparisons are auto-matched — just select the images you want to leave feedback on and skip or delete the rest.
                                </p>
                                <div className='justify-space-between'>
                                    <Checkbox
                                        checked={dontShowAgain}
                                        className="black-checkbox manrope f-14 w-400 black-00"
                                        onChange={changeTourVisibility}
                                    >
                                        Don't show again
                                    </Checkbox>

                                    <Button
                                        className="modal-okay square font-14"
                                        onClick={closeTour1}>
                                        OK
                                    </Button>
                                </div>
                            </div>
                        ),
                        style: { minWidth: 400 }
                    }
                ]}
                isOpen={tourStep == 1}
                className="helper"
                rounded={5}
                accentColor={"#D93025"}
                onAfterOpen={() => {
                    disableBody();
                }}
                // onBeforeClose={enableBody}
                maskClassName="custom-mask"
                disableDotsNavigation={true}
                closeWithMask={false}
                lastStepNextButton={<span></span>}
                nextButton={<span></span>}
                prevButton={<span></span>}
                scrollSmooth={false}
                disableInteraction={true} // Optional: to prevent auto focus/scroll
                showCloseButton={false}
                showNavigation={false}
                showNavigationNumber={false}
                showNumber={false}
                onRequestClose={() => setTourStep(-1)}
            />

        </Col>
    </Row>)

}

export default ProductCollaborateQAContainer;